import AdaptiveImage from "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "3f3cd372003b3c92fb86461610f38a48.png",
    width: 2386,
    height: 1624
});